import AppRowContainer from "@lib/components/AppComponents/AppRowContainer";
import { Col } from "antd";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { DateRangeFilter } from "@lib/components/MiniComponents/Others";
import {
  apiGetXAILeadsDashboard,
  apiGetXAICallLogsDashboard,
} from "@lib/api/xAI";
import dayjs from "dayjs";
import {
  TftSalesLeadsStatusChart,
  TftSalesLeadsDailyChart,
  TftSalesCallsStatusChart,
  TftSalesCallsAgentChart,
  TftSalesCallsDailyChart,
} from "@lib/components/MiniComponents/Dashboard/TftSales";
import {
  TftSalesLeadsMiniCard,
  TftSalesCallsMiniCard,
} from "@app/admin/dashboards/components/MiniCards";

type Props = {
  dateBetween: [string, string];
  setDateBetween: (date: [string, string]) => void;
};

const ManagementTftSales: React.FC<Props> = ({ dateBetween }) => {
  const dashboardParams = useMemo(() => {
    return {
      timeFrom: dayjs(dateBetween[0]).toISOString(),
      timeTo: dayjs(dateBetween[1]).toISOString(),
    };
  }, [dateBetween]);

  const leadsQuery = useQuery({
    queryKey: ["tft-sales-leads-management", JSON.stringify(dashboardParams)],
    queryFn: () => apiGetXAILeadsDashboard(dashboardParams),
    enabled: !!dashboardParams,
  });

  const callsQuery = useQuery({
    queryKey: ["tft-sales-calls-management", JSON.stringify(dashboardParams)],
    queryFn: () => apiGetXAICallLogsDashboard(dashboardParams),
    enabled: !!dashboardParams,
  });

  return (
    <AppRowContainer>
      <Col xs={24} md={12} lg={12} xl={12}>
        <TftSalesLeadsMiniCard cardProps={{ borderFull: true }} />
      </Col>
      <Col xs={24} md={12} lg={12} xl={12}>
        <TftSalesCallsMiniCard cardProps={{ borderFull: true }} />
      </Col>

      <Col xs={24} md={24} lg={12} xl={12}>
        <TftSalesLeadsStatusChart
          query={leadsQuery}
          extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
          refetch={() => leadsQuery.refetch()}
        />
      </Col>

      <Col xs={24} md={24} lg={12} xl={12}>
        <TftSalesCallsStatusChart
          query={callsQuery}
          extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
          refetch={() => callsQuery.refetch()}
        />
      </Col>

      <Col xs={24} md={24} lg={12} xl={12}>
        <TftSalesCallsAgentChart
          query={callsQuery}
          extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
          refetch={() => callsQuery.refetch()}
        />
      </Col>

      <Col xs={24} md={24} lg={12} xl={12}>
        <TftSalesLeadsDailyChart
          query={leadsQuery}
          extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
          refetch={() => leadsQuery.refetch()}
        />
      </Col>

      <Col xs={24} md={24} lg={24} xl={24}>
        <TftSalesCallsDailyChart
          query={callsQuery}
          extra={<DateRangeFilter value={dateBetween} onlyShowDate />}
          refetch={() => callsQuery.refetch()}
        />
      </Col>
    </AppRowContainer>
  );
};

export default ManagementTftSales;
